import Vue from 'vue'
import Vuex from 'vuex'
import testrideStore from './modules/testrideStore'
// import testrideServices from './modules/testrideServices'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    testrideStore: testrideStore,
    // testrideServices: testrideServices,
  }
})


export default store